function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M120.582 14.332h-89.8l.1 28.8 39.9-.1c-34 18-56.5 52.9-56.5 106 0 82.2 53.5 120 120 120.2v-28c-27.4-.1-50.2-7.7-66-21.9-17.3-15.7-26-39.3-26-70.2s8.8-54.7 26.1-70.5c7.1-6.4 15.2-11.4 24.1-14.8l.1 40.8 28.3-.1-.3-90.2zM162.882 269.132h89.8l-.1-28.7-39.9.1c34-18 56.5-52.9 56.5-106.1 0-82.2-53.5-120-120-120.2v28c27.4.1 50.2 7.7 66 21.9 17.3 15.7 26 39.3 26 70.2s-8.8 54.7-26.1 70.5c-7.1 6.4-15.2 11.4-24.1 14.8l-.1-40.8-28.3.1.3 90.2z"
})));